import { IStore } from "../../store-context";
import { filterObject } from "../../../utils/comments";
import { IAction } from "../..";
import {
  ICommentChild,
  ICommentParent,
  IDeleteCommentPayload,
  IGeneralComments,
  IGetCommentsRequest,
  IGetCommentsSuccess,
  // IGroup,
  ISpecificGroups
} from "../../types";
import { reducer } from "..";
import { CommentsAction } from "../../actions";

reducer.createHandler(
  CommentsAction.GetCommentRequest,
  (state: IStore, { payload: { general } }: IAction<IGetCommentsRequest>): IStore => {
    return {
      ...state,
      comments: {
        general: general ? {} : { ...state.comments.general },
        specific: !general ? {} : { ...state.comments.specific },
        generalLoading: general ? true : state.comments.generalLoading,
        specificLoading: !general ? true : state.comments.specificLoading,
        loading: false,
        error: undefined
      }
    };
  }
);

reducer.createHandler(
  CommentsAction.GetCommentSuccess,
  (state: IStore, { payload: { comments, general, formId } }: IAction<IGetCommentsSuccess>): IStore => {
    if (formId !== state.dealModule.form.data?.id) {
      return state;
    }

    return {
      ...state,
      comments: {
        general: general ? (comments as IGeneralComments) : state.comments.general,
        specific: general ? state.comments.specific : (comments as ISpecificGroups),
        generalLoading: general ? false : state.comments.generalLoading,
        specificLoading: !general ? false : state.comments.specificLoading,
        loading: false,
        error: undefined
      }
    };
  }
);

reducer.createHandler(CommentsAction.GetCommentFailure, (state: IStore, { payload }: any): IStore => {
  return {
    ...state,
    comments: {
      ...state.comments,
      loading: false,
      error: payload
    }
  };
});

export const createCommentSuccess = reducer.createHandler(
  CommentsAction.CreateCommentSuccess,
  (state: IStore, { payload }: IAction<ICommentParent | ICommentChild>): IStore => {
    const { question_id } = payload;

    if (!question_id?.question_uuid) {
      return {
        ...state,
        comments: {
          ...state.comments,
          general: payload.parent_id // is child
            ? {
                ...state.comments.general,
                [payload.parent_id]: {
                  ...state.comments.general[payload.parent_id],
                  child_comments: {
                    ...state.comments.general[payload.parent_id]?.child_comments,
                    [payload.id]: payload as ICommentChild
                  }
                }
              }
            : {
                ...state.comments.general,
                [payload.id]: payload as ICommentParent
              }
        }
      };
    } else {
      return {
        ...state,
        comments: {
          ...state.comments,
          specific: state.comments.specific[question_id.question_uuid]
            ? payload.parent_id // is child
              ? {
                  ...state.comments.specific,
                  [question_id.question_uuid]: {
                    ...state.comments.specific[question_id.question_uuid],
                    comments: {
                      ...state.comments.specific[question_id.question_uuid].comments,
                      [payload.parent_id]: {
                        ...state.comments.specific[question_id.question_uuid].comments[payload.parent_id],
                        child_comments: {
                          ...state.comments.specific[question_id.question_uuid].comments[payload.parent_id]
                            ?.child_comments,
                          [payload.id]: payload as ICommentChild
                        }
                      }
                    }
                  }
                }
              : {
                  ...state.comments.specific,
                  [question_id.question_uuid]: {
                    ...state.comments.specific[question_id.question_uuid],
                    comments: {
                      ...state.comments.specific[question_id.question_uuid].comments,
                      [payload.id]: payload as ICommentParent
                    }
                  }
                }
            : {
                ...state.comments.specific,
                [question_id.question_uuid]: {
                  uuid: question_id.question_uuid,
                  label: question_id.label,
                  comments: {
                    [payload.id]: payload as ICommentParent
                  }
                }
              }
        },
        dealModule: {
          //ADDING FILTER WITH_COMMENTS FOR QUESTION, TO COMMENT WHICH YOU POSTED
          ...state.dealModule,
          form: {
            ...state.dealModule.form
          }
          // questions: state.survey.questions.map((group: IGroup) => {
          //   if (
          //     group.questions[question_uuid.question_uuid as string] &&
          //     !group.questions[
          //       question_uuid.question_uuid as string
          //     ].filters.includes("with_comments")
          //   ) {
          //     const filters =
          //       group.questions[question_uuid.question_uuid as string].filters;
          //     return {
          //       ...group,
          //       questions: {
          //         ...group.questions,
          //         [question_uuid.question_uuid as string]: {
          //           ...group.questions[question_uuid.question_uuid as string],
          //           filters: [...filters, "with_comments"],
          //         },
          //       },
          //     };
          //   }
          //   return group;
          // }),
        }
      };
    }
  }
);

reducer.createHandler(
  CommentsAction.UpdateCommentSuccess,
  (state: IStore, { payload }: IAction<ICommentParent>): IStore => {
    const { question_uuid } = payload;

    if (question_uuid) {
      return {
        ...state,
        comments: {
          ...state.comments,
          specific: {
            ...state.comments.specific,
            [question_uuid]: {
              ...state.comments.specific[question_uuid],
              comments: {
                ...state.comments.specific[question_uuid].comments,
                [payload.id]: payload
              }
            }
          }
        }
      };
    } else {
      return {
        ...state,
        comments: {
          ...state.comments,
          general: {
            ...state.comments.general,
            [payload.id]: payload
          }
        }
      };
    }
  }
);

reducer.createHandler(
  CommentsAction.DeleteCommentSuccess,
  (state: IStore, { payload }: IAction<IDeleteCommentPayload>): IStore => {
    const { questionUuid, id } = payload;

    // const questionComments =
    //   state.comments.specific[questionUuid as string].comments;

    if (questionUuid) {
      return {
        ...state,
        comments: {
          ...state.comments,
          specific: {
            ...state.comments.specific,
            [questionUuid]: {
              ...state.comments.specific[questionUuid],
              comments: {
                ...filterObject([id], state.comments.specific[questionUuid].comments)
              }
            }
          }
        },
        dealModule: {
          //ADDING FILTER WITH_COMMENTS FOR QUESTION, TO COMMENT WHICH YOU POSTED
          ...state.dealModule,
          form: {
            ...state.dealModule.form
          }
          // questions: state.survey.questions.map((group: IGroup) => {
          //   if (
          //     group.questions[questionUuid] &&
          //     group.questions[questionUuid].filters.includes("with_comments") &&
          //     !Object.keys(questionComments).length
          //   ) {
          //     const filters = group.questions[questionUuid].filters;
          //     return {
          //       ...group,
          //       questions: {
          //         ...group.questions,
          //         [questionUuid]: {
          //           ...group.questions[questionUuid],
          //           filters: filters.filter(
          //             (filter: string) => filter !== "with_comments"
          //           ),
          //         },
          //       },
          //     };
          //   }
          //   return group;
          // }),
        }
      };
    } else {
      return {
        ...state,
        comments: {
          ...state.comments,
          general: { ...filterObject([id], state.comments.general) }
        }
      };
    }
  }
);

reducer.createHandler(
  CommentsAction.CreateCommentSocket,
  (state: IStore, { payload }: IAction<ICommentParent | ICommentChild>): IStore => {
    // Don't handle if it's not relevant questionnaire
    const id = state.dealModule.form.data?.id;
    if (id !== payload.form_id) {
      console.log("[Socket handler] - the questionnaire is not relevant");
      return state;
    }

    // Don't handle if it's yours comment
    const {
      userModule: { user }
    } = state;
    if (user?.id === payload?.user?.id) {
      console.log("[Socket handler] - this is yours comment");
      return state;
    }

    const { question_id } = payload;

    if (!question_id || !question_id?.question_uuid) {
      return {
        ...state,
        comments: {
          ...state.comments,
          general: payload.parent_id // is child?
            ? {
                ...state.comments.general,
                [payload.parent_id]: {
                  ...state.comments.general[payload.parent_id],
                  child_comments: {
                    ...state.comments.general[payload.parent_id]?.child_comments,
                    [payload.id]: payload as ICommentChild
                  }
                }
              }
            : {
                ...state.comments.general,
                [payload.id]: payload as ICommentParent
              }
        }
      };
    } else {
      return {
        ...state,
        comments: {
          ...state.comments,
          specific: state.comments.specific[question_id.question_uuid]
            ? payload.parent_id // is child?
              ? {
                  ...state.comments.specific,
                  [question_id.question_uuid]: {
                    ...state.comments.specific[question_id.question_uuid],
                    comments: {
                      ...state.comments.specific[question_id.question_uuid].comments,
                      [payload.parent_id]: {
                        ...state.comments.specific[question_id.question_uuid].comments[payload.parent_id],
                        child_comments: {
                          ...state.comments.specific[question_id.question_uuid].comments[payload.parent_id]
                            ?.child_comments,
                          [payload.id]: payload as ICommentChild
                        }
                      }
                    }
                  }
                }
              : {
                  ...state.comments.specific,
                  [question_id.question_uuid]: {
                    ...state.comments.specific[question_id.question_uuid],
                    comments: {
                      ...state.comments.specific[question_id.question_uuid].comments,
                      [payload.id]: payload as ICommentParent
                    }
                  }
                }
            : {
                ...state.comments.specific,
                [question_id.question_uuid]: {
                  uuid: question_id.question_uuid,
                  label: question_id.label,
                  comments: {
                    [payload.id]: payload as ICommentParent
                  }
                }
              }
        },
        dealModule: {
          //ADDING FILTER WITH_COMMENTS FOR QUESTION, TO COMMENT WHICH YOU POSTED
          ...state.dealModule,
          form: {
            ...state.dealModule.form
          }
          // questions: state.survey.questions.map((group: IGroup) => {
          //   if (
          //     group.questions[question_uuid.question_uuid as string] &&
          //     !group.questions[
          //       question_uuid.question_uuid as string
          //     ].filters.includes("with_comments")
          //   ) {
          //     const filters =
          //       group.questions[question_uuid.question_uuid as string].filters;
          //     return {
          //       ...group,
          //       questions: {
          //         ...group.questions,
          //         [question_uuid.question_uuid as string]: {
          //           ...group.questions[question_uuid.question_uuid as string],
          //           filters: [...filters, "with_comments"],
          //         },
          //       },
          //     };
          //   }
          //   return group;
          // }),
        }
      };
    }
  }
);

reducer.createHandler(
  CommentsAction.UpdateCommentSocket,
  (state: IStore, { payload }: IAction<ICommentParent>): IStore => {
    // Don't handle if it's not relevant questionnaire
    const id = state.dealModule.form.data?.id;
    if (id !== payload.form_id) {
      console.log("[Socket handler] - the questionnaire is not relevant");
      return state;
    }

    // Don't handle if it's yours comment
    const {
      userModule: { user }
    } = state;
    if (user?.id === payload?.user?.id) {
      console.log("[Socket handler] - this is yours comment");
      return state;
    }

    const { question_uuid } = payload;

    if (question_uuid) {
      return {
        ...state,
        comments: {
          ...state.comments,
          specific: {
            ...state.comments.specific,
            [question_uuid]: {
              ...state.comments.specific[question_uuid],
              comments: {
                ...state.comments.specific[question_uuid].comments,
                [payload.id]: payload
              }
            }
          }
        }
      };
    } else {
      return {
        ...state,
        comments: {
          ...state.comments,
          general: {
            ...state.comments.general,
            [payload.id]: payload
          }
        }
      };
    }
  }
);

reducer.createHandler(
  CommentsAction.DeleteCommentSocket,
  (state: IStore, { payload }: IAction<ICommentParent>): IStore => {
    // Don't handle if it's not relevant questionnaire
    const formId = state.dealModule.form.data?.id;
    const {
      dealModule: {
        deal: { id: dealId }
      },
      userModule: { user }
    } = state;
    if (formId !== payload.form_id) {
      console.log("[Socket handler] - the questionnaire is not relevant");
      return state;
    }

    if (dealId !== payload.deal_id) {
      console.log("[Socket handler] - the deal is not relevant");
      return state;
    }

    // Don't handle if it's yours comment
    if (user?.id === payload?.user?.id) {
      console.log("[Socket handler] - this is yours comment");
      return state;
    }

    const { question_uuid } = payload;

    // const questionComments =
    //   state.comments.specific[question_uuid.question_uuid as string].comments;

    if (question_uuid) {
      return {
        ...state,
        comments: {
          ...state.comments,
          specific: {
            ...state.comments.specific,
            [question_uuid]: {
              ...state.comments.specific[question_uuid],
              comments: {
                ...filterObject([payload?.id], state.comments.specific[question_uuid].comments)
              }
            }
          }
        },
        dealModule: {
          //ADDING FILTER WITH_COMMENTS FOR QUESTION, TO COMMENT WHICH YOU POSTED
          ...state.dealModule,
          form: {
            ...state.dealModule.form
          }
          // questions: state.survey.questions.map((group: IGroup) => {
          //   if (
          //     group.questions[question_uuid.question_uuid as string] &&
          //     group.questions[
          //       question_uuid.question_uuid as string
          //     ].filters.includes("with_comments") &&
          //     !Object.keys(questionComments).length
          //   ) {
          //     const filters =
          //       group.questions[question_uuid.question_uuid as string].filters;
          //     return {
          //       ...group,
          //       questions: {
          //         ...group.questions,
          //         [question_uuid.question_uuid as string]: {
          //           ...group.questions[question_uuid.question_uuid as string],
          //           filters: filters.filter(
          //             (filter: string) => filter !== "with_comments"
          //           ),
          //         },
          //       },
          //     };
          //   }
          //   return group;
          // }),
        }
      };
    } else {
      return {
        ...state,
        comments: {
          ...state.comments,
          general: { ...filterObject([payload?.id], state.comments.general) }
        }
      };
    }
  }
);
